module.exports = __webpack_public_path__ + "static/media/pulmonologyImage3@3x.27d55f14.png";